import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8a377a06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "roles-view" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-3 mb-3" }, "No placeholders have been used in the template so far.", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_feather_icon = _resolveComponent("feather-icon")!
  const _component_LogoAndName = _resolveComponent("LogoAndName")!
  const _component_user_selection = _resolveComponent("user-selection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.placeholders.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.placeholders, (placeholder) => {
      return (_openBlock(), _createElementBlock("div", {
        key: placeholder.placeholderId,
        class: "user-selection-wrapper mb-2"
      }, [
        _createVNode(_component_user_selection, {
          selectedUsers: _ctx.selectedPlaceholder[placeholder.placeholderId],
          "onUpdate:selectedUsers": ($event: any) => ((_ctx.selectedPlaceholder[placeholder.placeholderId]) = $event),
          exactlyOne: true,
          hidePlaceholder: true,
          label: "Placeholder Matching"
        }, {
          default: _withCtx(() => [
            (_ctx.selectedPlaceholder[placeholder.placeholderId] && _ctx.selectedPlaceholder[placeholder.placeholderId].length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createTextVNode(_toDisplayString(placeholder.name) + ": ", 1),
                  _createVNode(_component_feather_icon, {
                    type: "trash",
                    stroke: "rgba(31, 50, 69, 0.5)",
                    size: "16",
                    class: "mt-1 float-end",
                    onClick: ($event: any) => (_ctx.selectedPlaceholder[placeholder.placeholderId] = [])
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_LogoAndName, {
                    user: _ctx.selectedPlaceholder[placeholder.placeholderId][0],
                    rowView: true
                  }, null, 8, ["user"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createTextVNode(_toDisplayString(placeholder.name) + " ", 1),
                  _createVNode(_component_feather_icon, {
                    type: "chevron-right",
                    stroke: "rgba(31, 50, 69, 0.5)",
                    size: "20",
                    class: "float-end"
                  })
                ]))
          ]),
          _: 2
        }, 1032, ["selectedUsers", "onUpdate:selectedUsers"])
      ]))
    }), 128))
  ]))
}